import { LOADED, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useTagListStore, } from '@/assets/js/src/modules/tag/_pinia/tagList'
import { computed, ref, watch, } from 'vue'
import { useComponentIsActive, } from '@/assets/js/src/util/composables/useComponentIsActive'
import { COLOR_SORT, debounce, USER_COUNT_SORT, } from '@/assets/js/src/util/uiTools'
import { mapUserOptionByPath, } from '@/assets/js/src/modules/user/_pinia/mapUserOptionByPath'
import { useUserOptions, } from '@/assets/js/src/modules/user/_composables/useUserOptions'

export function useTagListApi () {
    let activePinia = getActivePinia()
    let tagListStore = useTagListStore(activePinia)
    let { tags,reload,search, } = storeToRefs(tagListStore)

    let { messagesLoaded,asyncStatus,updateData, } = usePrefetchData({
        actions: [
            {
                item: tags,
                action: tagListStore.getTags,
                payload: { page: 1, },
            },
        ],
        loadAsyncMessages: [ 'tag', 'common', ],
    })

    let { componentIsActive, } = useComponentIsActive()

    watch(reload, async (newBoolean, oldBoolean) => {
        if (newBoolean && newBoolean !== oldBoolean && componentIsActive) {
            await updateData()
            tagListStore.reload = false
        }
    })

    const debouncedSearch = ref(search.value)
    watch(debouncedSearch,
        debounce((newVal) => search.value = newVal, 300),
        { immediate: !import.meta.env.SSR, })
    watch(search,()=>{
        tagListStore.reload = false
        setTimeout(()=>{
            tagListStore.reload = true
        })
    })

    const debouncedMy = computed(mapUserOptionByPath('tag/list/my'))
    watch(debouncedMy, () => tagListStore.reload = true)

    let { getUserOption, } = useUserOptions()
    let my = ref(getUserOption('tag/list/my'))
    watch(my,
        debounce((newVal) => {
            debouncedMy.value = newVal
            if(sort.value === COLOR_SORT) {
                sort.value = USER_COUNT_SORT
            }
        }, 300),
        { immediate: !import.meta.env.SSR, })

    const sort = computed(mapUserOptionByPath('tag/list/sort'))
    watch(sort,()=>tagListStore.reload = true)

    const gridView = computed(mapUserOptionByPath('tag/gridView'))

    const asyncStatusLoaded = computed(()=>asyncStatus.value === LOADED)

    return {
        messagesLoaded,
        asyncStatusLoaded,
        tags,
        debouncedSearch,
        my,
        componentIsActive,
        sort,
        gridView,
    }
}
